var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2299 3.76988C19.3299 2.86988 18.1399 2.37988 16.8699 2.37988C15.5999 2.37988 14.4099 2.86988 13.5099 3.76988L4.03991 13.2399C3.64991 13.6299 3.38991 14.1099 3.28991 14.6499L2.28991 19.6599C2.16991 20.2399 2.34991 20.8299 2.76991 21.2399C3.09991 21.5699 3.54991 21.7499 4.00991 21.7499C4.11991 21.7499 4.23991 21.7399 4.34991 21.7199L9.35991 20.7199C9.88991 20.6099 10.3799 20.3499 10.7699 19.9699L20.2399 10.4999C21.1399 9.59988 21.6299 8.40988 21.6299 7.13988C21.6299 5.86988 21.1399 4.67988 20.2399 3.77988L20.2299 3.76988ZM4.04991 20.2399C3.93991 20.2599 3.85991 20.2099 3.81991 20.1699C3.77991 20.1299 3.72991 20.0599 3.74991 19.9399L4.59991 15.7099L8.27991 19.3899L4.04991 20.2399ZM19.1699 9.42988L9.79991 18.7999L5.19991 14.1999L14.5699 4.82988C15.1999 4.19988 16.0399 3.87988 16.8699 3.87988C17.6999 3.87988 18.5299 4.19988 19.1699 4.82988C20.4399 6.09988 20.4399 8.15988 19.1699 9.42988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8c522c2f9147627b59ae6858d326bd49.svg";
export { ForwardRef as ReactComponent };